import React, { useCallback, useEffect, useMemo } from "react";
import { useObjectStore } from "../zustand/objects";
import { IconArrowBackUp } from '@tabler/icons-react';
import EditorToolbarIcon from "./EditorToolbarIcon";
import { CHROME_TOOLBAR_ICON_GLYPH } from "../utils/editorChromeTheme";

const UndoButton = ({ undoActions, redoActions, iconColour, inGroup = false }) => {
  const {
    sendUpdateToChannel,
    arrangeUndoRedo,
    undoActions: storeUndoActions,
    redoActions: storeRedoActions
  } = useObjectStore();

  const actionsToUse = useMemo(() => {
    return {
      undo: Array.isArray(undoActions) ? undoActions : storeUndoActions,
      redo: Array.isArray(redoActions) ? redoActions : storeRedoActions,
    };
  }, [undoActions, redoActions, storeUndoActions, storeRedoActions]);

  const asyncUndo = useCallback(async (data) => {
    arrangeUndoRedo(data)
  }, [arrangeUndoRedo])

  const handleUndoClick = useCallback(() => {
    const data = actionsToUse.undo[0]
    asyncUndo(data).then(() =>
      sendUpdateToChannel(data))

  }, [asyncUndo, sendUpdateToChannel, actionsToUse.undo])

  const handleRedoClick = useCallback(() => {
    const data = actionsToUse.redo[0]
    asyncUndo(data).then(() =>
      sendUpdateToChannel(data))
  }, [asyncUndo, sendUpdateToChannel, actionsToUse.redo])

  useEffect(() => {
    function handleKeyDown(event) {
      if (event.repeat) { return }
      if (event.key === 'z' && (event.ctrlKey || event.metaKey) && !event.shiftKey) {
        actionsToUse.undo.length > 0 && handleUndoClick()
      }
      if (event.key === 'z' && (event.ctrlKey || event.metaKey) && event.shiftKey) {
        actionsToUse.redo.length > 0 && handleRedoClick()
      }
    }
    document.addEventListener("keydown", handleKeyDown)

    return () => document.removeEventListener("keydown", handleKeyDown)
  }, [handleRedoClick, handleUndoClick, actionsToUse.undo.length, actionsToUse.redo.length])

  return (
    <EditorToolbarIcon
      label="Undo"
      disabled={actionsToUse.undo.length <= 0}
      onClick={handleUndoClick}
      iconColour={iconColour}
      inGroup={inGroup}
    >
      <IconArrowBackUp size={CHROME_TOOLBAR_ICON_GLYPH} />
    </EditorToolbarIcon>
  );
};

export default UndoButton;
